(function () {
  var btn = document.getElementById('close-search-inline');
  if (!btn) return;

  btn.addEventListener('click', function () {
    var toggle = document.querySelector('.head-slot-global-search-link');
    if (toggle && typeof toggle.click === 'function') {
      toggle.click();
      return;
    }

    var ps = document.querySelector('.predictive-search-header');
    if (ps) ps.setAttribute('hidden', 'hidden');

    var input = document.getElementById('header-global-search-input');
    if (input) input.blur();
  });
})();
